export default __webpack_public_path__ + "static/media/logo-sauce.35970b21.svg";